export const datasetControlTranslations = {
    "search": { 1029: "Vyhledat", 1033: "Search" },
    "records": { 1029: "záznamy", 1033: "records" }
};
   
